// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1tfTB","selected":"Chip_selected__NO8v_"};